import { WalletIcon } from '@/ui/Icons/WalletIcon';
import {
  MatchaTooltip,
  MatchaTooltipBottomSheet,
  MatchaTooltipContent,
  MatchaTooltipPopover,
  MatchaTooltipTrigger,
} from '@/ui/MatchaTooltip';

import { abbreviateNumber } from '@/utils/numbers';

type TokenHoldersBadgeProps = {
  /** Number of unique addresses holding the token. */
  holders: number;
};

export const TokenHoldersBadge = ({ holders }: TokenHoldersBadgeProps) => (
  <MatchaTooltip>
    <MatchaTooltipTrigger>
      <button type="button" className="flex flex-row items-center gap-1 cursor-default">
        <WalletIcon className="text-token-gray-700" />
        {abbreviateNumber(holders, 1, true)}
      </button>
    </MatchaTooltipTrigger>
    <MatchaTooltipContent>Holders</MatchaTooltipContent>
    <MatchaTooltipPopover sideOffset={8} />
    <MatchaTooltipBottomSheet header="Holders" />
  </MatchaTooltip>
);
